import { useRef } from 'react';
import messages from './intl/index.js';
import { jsx } from 'react/jsx-runtime';
import { useThemeVariable } from '../util/useThemeVariable.js';
import { useMessageFormatter } from '../i18n/format.js';
import { Text } from '../text/Text.js';

/**
 * A required label for usage in a form.
 */
function Required(props) {
  const ref = useRef(null);
  const requiredStyle = useThemeVariable('UNSAFE-input-required-style', ref);
  const requiredEl = requiredStyle === 'star' ? /*#__PURE__*/jsx(LegacyDsxRequired, {
    ...props
  }) : /*#__PURE__*/jsx(DefaultDsxRequired, {
    ...props
  });
  return /*#__PURE__*/jsx("span", {
    className: "dsx-component",
    ref: ref,
    children: requiredEl
  });
}
function LegacyDsxRequired(props) {
  const {
    required,
    showIndicator,
    ...rest
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages);
  if (!required) {
    return null;
  }
  return /*#__PURE__*/jsx(Text, {
    variant: "helper",
    color: "color-danger",
    element: "span",
    "aria-label": formatMessage('required'),
    ...rest,
    children: "*"
  });
}
function DefaultDsxRequired(props) {
  const {
    required,
    showIndicator,
    ...rest
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages);
  const showThisIndicator = showIndicator === 'required' && required || showIndicator === 'optional' && !required;
  if (!showThisIndicator) {
    return null;
  }
  const message = required ? formatMessage('required') : formatMessage('optional');
  return /*#__PURE__*/jsx(Text, {
    variant: "helper",
    element: "em",
    ...rest,
    children: message
  });
}

export { Required };
